import React from 'react';
import exact from 'prop-types-exact';

import OvertimeDetails from './index';
import PageLayout from '../../layouts/PageLayout';

const propTypes = exact({});


const OvertimePage = () => {
  return (
    <PageLayout
      title="Weekly Hours Report"
      render={() => { return <OvertimeDetails />; }}
    />
  );
};

OvertimePage.propTypes = propTypes;

export default OvertimePage;
